import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "subtle-box mb-3"
};
const _hoisted_2 = {
    key: 0,
    class: "table-title px-2"
};
const _hoisted_3 = {
    key: 1,
    class: "px-2 pt-1"
};
const _hoisted_4 = { style: { "border-top": "0" } };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { key: 0 };
const _hoisted_7 = ["colspan"];
const _hoisted_8 = ["colspan"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["colspan"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FilterInput = _resolveComponent("FilterInput");
    const _component_Icon = _resolveComponent("Icon");
    const _component_Tooltip = _resolveComponent("Tooltip");
    return (_ctx.tableDataToUse)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.tableDataToUse.headers.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.caption), 1))
                : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "afterHeader", {}, undefined, true),
            (_ctx.allowFilter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_FilterInput, {
                        list: _ctx.tableDataToUse.rows,
                        extractTextToFilterFunc: _ctx.extractRowText,
                        debounceMs: 250,
                        onOnFilter: _ctx.onFilter
                    }, null, 8, ["list", "extractTextToFilterFunc", "onOnFilter"])
                ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", {
                class: _normalizeClass(["table-responsive", { 'virtual-scroll': _ctx.shouldVirtualize }]),
                style: _normalizeStyle(_ctx.scrollContainerStyle),
                ref: "scrollContainer",
                onScroll: _cache[3] || (_cache[3] =
                    //@ts-ignore
                    (...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
            }, [
                _createElementVNode("table", {
                    class: _normalizeClass('table table-hover table-sm mb-0 pb-0 table-borderless' +
                        (_ctx.shouldVirtualize ? '' : ' table-striped') +
                        (_ctx.noFixedTable ? '' : ' fixed-table'))
                }, [
                    _createElementVNode("thead", _hoisted_4, [
                        _createElementVNode("tr", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableDataToUse.headers, (header) => {
                                return (_openBlock(), _createElementBlock("th", {
                                    key: header.text,
                                    class: "sticky-header px-2 cell",
                                    style: _normalizeStyle('font-weight: 550;' +
                                        (header.width
                                            ? 'width:' + header.width + 'px;'
                                            : '') +
                                        (_ctx.isHeaderSortable(header)
                                            ? 'cursor: pointer;'
                                            : '')),
                                    onClick: ($event) => (_ctx.headerClick(header))
                                }, [
                                    (_ctx.isHeaderSortable(header))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                            _createVNode(_component_Icon, {
                                                style: { "color": "#212529" },
                                                icon: ['fa', _ctx.headerIcon(header)]
                                            }, null, 8, ["icon"]),
                                            _cache[4] || (_cache[4] = _createTextVNode("  ", -1))
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createVNode(_component_Tooltip, {
                                        tip: _ctx.getHeaderToolTipText(header)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(header.text), 1)
                                        ]),
                                        _: 2
                                    }, 1032, ["tip"])
                                ], 12, _hoisted_5));
                            }), 128))
                        ])
                    ]),
                    _createElementVNode("tfoot", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", {
                                colspan: _ctx.tableData?.headers.length,
                                class: "px-2"
                            }, [
                                _cache[5] || (_cache[5] = _createTextVNode(" Download as ", -1)),
                                _createElementVNode("a", {
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.download('csv')), ["prevent"])),
                                    class: "link-primary"
                                }, "CSV"),
                                _cache[6] || (_cache[6] = _createTextVNode(", ", -1)),
                                _createElementVNode("a", {
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.download('xlsx')), ["prevent"])),
                                    class: "link-primary"
                                }, "XLSX"),
                                _cache[7] || (_cache[7] = _createTextVNode(", or ", -1)),
                                _createElementVNode("a", {
                                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.download('json')), ["prevent"])),
                                    class: "link-primary"
                                }, "JSON")
                            ], 8, _hoisted_7)
                        ])
                    ]),
                    _createElementVNode("tbody", null, [
                        (_ctx.virtualWindow.topPad > 0)
                            ? (_openBlock(), _createElementBlock("tr", {
                                key: 0,
                                class: "virtual-spacer",
                                style: _normalizeStyle({ height: _ctx.virtualWindow.topPad + 'px' })
                            }, [
                                _createElementVNode("td", {
                                    colspan: _ctx.tableDataToUse.headers.length
                                }, null, 8, _hoisted_8)
                            ], 4))
                            : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.virtualWindow.rows, (row, localIdx) => {
                            return (_openBlock(), _createElementBlock("tr", {
                                key: _ctx.virtualWindow.startIdx + localIdx,
                                class: _normalizeClass({ 'row-striped': _ctx.shouldVirtualize && (_ctx.virtualWindow.startIdx + localIdx) % 2 === 0 })
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableDataToUse.headers, (header) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                        key: header.text,
                                        onClick: ($event) => (_ctx.rowClicked(_ctx.virtualWindow.startIdx + localIdx, _ctx.getCell(row[header.text]).val.toString())),
                                        class: "cell px-2",
                                        style: _normalizeStyle(_ctx.clickableRows ? 'cursor: pointer;' : '')
                                    }, [
                                        _createVNode(_component_Tooltip, {
                                            tip: _ctx.getCellToolTipText(_ctx.getCell(row[header.text]))
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("span", {
                                                    innerHTML: _ctx.getCell(row[header.text]).val
                                                }, null, 8, _hoisted_10),
                                                (_ctx.showIcon(_ctx.getCell(row[header.text]), row))
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        class: "icon-clickable",
                                                        onClick: _withModifiers(($event) => (_ctx.iconClicked(_ctx.getCell(row[header.text])
                                                            .iconClickEmitName, row)), ["stop"])
                                                    }, [
                                                        _createVNode(_component_Icon, {
                                                            icon: _ctx.getCell(row[header.text])
                                                                .iconClasses
                                                        }, null, 8, ["icon"])
                                                    ], 8, _hoisted_11))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                        }, 1032, ["tip"])
                                    ], 12, _hoisted_9));
                                }), 128))
                            ], 2));
                        }), 128)),
                        (_ctx.virtualWindow.bottomPad > 0)
                            ? (_openBlock(), _createElementBlock("tr", {
                                key: 1,
                                class: "virtual-spacer",
                                style: _normalizeStyle({ height: _ctx.virtualWindow.bottomPad + 'px' })
                            }, [
                                _createElementVNode("td", {
                                    colspan: _ctx.tableDataToUse.headers.length
                                }, null, 8, _hoisted_12)
                            ], 4))
                            : _createCommentVNode("", true)
                    ])
                ], 2)
            ], 38)
        ]))
        : _createCommentVNode("", true);
}
